
<el-container class="screen-parameters screen-parameters-fullHeight services stats">
  <div class="clients-panel">
    <div class="clients-panel-container">
      <el-row class="dateChooser black-inputs" :gutter="5">
        <el-col :span="24" class="stats-inputs">
          <el-date-picker class="datePicker" ref="picker" v-model="dates" type="daterange" range-separator="au"
            start-placeholder="Date de début" end-placeholder="Date de fin" format="dd/MM/yyyy" />
          <el-button :disabled="!(dates && dates.length === 2)" type="primary" @click="handleLoadStats()"
            :loading="getLoading">Voir les stats</el-button>
          <el-button v-if="getStats" class="dark" type="primary" @click="exportClients()"
            :loading="exportIsLoading">Exporter les stats</el-button>
        </el-col>
      </el-row>
      <el-row class="black-inputs" v-if="getStats">
        <el-col :span="24" class="screen-clients">
          <el-table ref="multipleTable" :data="getStats" :default-sort="{ prop: 'ts', order: 'ascending' }">
            <el-table-column prop="ts" label="ts" sortable :formatter="formatteTs">
            </el-table-column>
            <el-table-column prop="subs" label="Nombre de réservations">
            </el-table-column>
            <el-table-column prop="resas" label="Resas" sortable>
            </el-table-column>
            <el-table-column prop="resasNoShow" label="No show" sortable>
            </el-table-column>
            <el-table-column v-if="getAvailableColumns.permanence" prop="permanence" label="Permanence" sortable>
            </el-table-column>
            <el-table-column v-if="getAvailableColumns.web" prop="web" label="Web" sortable>
            </el-table-column>
            <el-table-column v-if="getAvailableColumns.restaurant" prop="restaurant" label="Restaurant" sortable>
            </el-table-column>
            <el-table-column v-if="getAvailableColumns.google" prop="google" label="Google" sortable>
            </el-table-column>
            <el-table-column v-if="getAvailableColumns.instagram" prop="instagram" label="Instagram" sortable>
            </el-table-column>
            <el-table-column v-if="getAvailableColumns.facebook" prop="facebook" label="Facebook" sortable>
            </el-table-column>
          </el-table>
          <div style="text-align: center;margin-top: 30px;">
            <el-pagination background layout="prev, pager, next" :page-count="getTotalPages"
              :current-page="currentPage" @current-change="current_change">
            </el-pagination>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</el-container>
